import { handleActions } from 'redux-actions';
import Immutable from 'immutable';

const MenuState = Immutable.fromJS({
	category: '',
	menu: {
		show: true,
		max: 12,
		xs: 4,
		sm: 3,
		md: 2,
	    banner : false,
	},
});

const menuReducer = handleActions({
	SWITCH_FUNCTION_CATEGORY: (state, { payload }) => {
		return state.merge({
			category: payload
		})
	},

	TOGGLE_MENU: (state, { payload }) => {
		return state.updateIn(['menu', 'show'], value => !value).merge();
	},

	MENU_EXPAND_MAX: (state, { payload }) => {
		state = state.updateIn(['menu', 'show'], value => !value);
		state = state.updateIn(['menu','banner'], value => !value);
		return state.merge();
	},

	 

}, MenuState);

export default menuReducer;


// WEBPACK FOOTER //
// ./src/reducers/menuReducer.js